import React from 'react';
import { twMerge } from 'tailwind-merge';

export interface TypographyProps {
  className?: string;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'div';
  children: React.ReactNode;
}
export function Typography({
  children,
  className,
  as: Component = 'span',
}: TypographyProps) {
  const classNames = twMerge('text-white text-lg', className);
  return <Component className={classNames}>{children}</Component>;
}

export const buildTypography =
  (baseClassName: string) => (props: TypographyProps) => {
    const { as, children, className } = props;

    return (
      <Typography className={twMerge(baseClassName, className)} as={as}>
        {children}
      </Typography>
    );
  };
